declare global {
  interface Window {
    dataLayer: any[]
  }
}

interface ClickLoadObjectTypes {
  name: string
  category: string
  action: string
  value?: string
  mocked?: boolean
}

interface VisitedPageTypes {
  path: string
  title: string
}

interface DataLayerEventProps {
  eventName: string
  [key: string]: any
}

const isProduction = () =>
  !window?.location?.host?.includes('homolog') && !window?.location?.host?.includes('localhost')

const pushToDataLayer = (event: string, payload: Record<string, any>) => {
  if (!isProduction()) return

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ event, ...payload })
}

// Toda a coleta passa pelo dataLayer do GTM (GTM-5ZTKGJF). O envio direto via
// react-ga4 foi removido: ele inicializava uma segunda instancia do mesmo
// measurement id ja carregado pelo GTM, duplicando page_view e eventos.
// Cada evento abaixo precisa de um acionador de Evento Personalizado no
// container para virar tag no GA4.
const SendVisitedPage = ({ path, title }: VisitedPageTypes) => {
  pushToDataLayer('page_view', { page_path: path, page_title: title })
}

const ClickSendObjectEvent = ({ name, action, category, value, mocked }: ClickLoadObjectTypes) => {
  pushToDataLayer(name, {
    category,
    action,
    value,
    label: mocked ? 'Data Mock' : 'Real Data'
  })
}

const SendDataLayer = (props: DataLayerEventProps) => {
  const { eventName, ...eventData } = props

  pushToDataLayer(eventName, eventData)
}

// Compra Recorrente (007): eventos de contracts/ui-contract.md. Nunca ids
// internos; no cancelamento só o valor do select, nunca o texto livre.
export type RecurrencyEventName =
  | 'recurrency_adhesion'
  | 'recurrency_edit'
  | 'recurrency_skip'
  | 'recurrency_postpone'
  | 'recurrency_pause'
  | 'recurrency_resume'
  | 'recurrency_cancel'

export type RecurrencyEventPayload = {
  origin: 'checkout' | 'post_purchase' | 'my_subscriptions'
  cycleDays?: number
  items?: Array<{ productId: number; quantity: number }>
  change?: 'quantity' | 'cycle' | 'card' | 'add_item' | 'remove_item'
  reason?: string
  // 009: só no `recurrency_adhesion`.
  documentsPending?: boolean
}

export const trackRecurrency = (event: RecurrencyEventName, payload: RecurrencyEventPayload) => {
  pushToDataLayer(event, payload)
}

const getEvents = {
  eventVisitedPage: (data: VisitedPageTypes) => SendVisitedPage(data),
  eventLoadObjects: (data: ClickLoadObjectTypes) => ClickSendObjectEvent(data),
  eventSendDataLayer: (data: DataLayerEventProps) => SendDataLayer(data)
}

export { getEvents }
